import { lazy, Suspense, useCallback, useContext, useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import useMediaQuery from '@mui/material/useMediaQuery';
import { LayoutContext } from '../../context';
import { theme } from '../../App';
import { useTestSession } from './useTestSession';
import ApexView from './skins/ApexView';
const ExamView = lazy(() => import('./skins/ExamView'));

const SKIN_KEY = 'apex_test_skin';

/** Скин берём из адреса (?skin=exam — быстрый просмотр), иначе из сохранённого выбора. */
function initialSkin() {
    const fromQuery = new URLSearchParams(window.location.search).get('skin');
    if (fromQuery === 'exam' || fromQuery === 'apex') return fromQuery;
    return localStorage.getItem(SKIN_KEY) === 'exam' ? 'exam' : 'apex';
}

/**
 * Связующее звено: механика из хука, вёрстка из скина.
 * Скин переключается на ходу и переживает перезагрузку.
 */
export default function TestSessionPage() {
    const { testId } = useParams();
    const navigate = useNavigate();
    const { token, user } = useContext(LayoutContext);
    const isAdmin = user?.role === 'admin';
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const session = useTestSession({ testId, token, navigate, isMobile });

    const [skin, setSkinState] = useState(initialSkin);
    const setSkin = useCallback((next) => {
        localStorage.setItem(SKIN_KEY, next);
        setSkinState(next);
    }, []);

    const view = { ...session, isAdmin, isMobile, token, navigate, skin, setSkin };

    return skin === 'exam' ? (
        <Suspense fallback={<div>Загрузка экзамена…</div>}>
            <ExamView session={view} />
        </Suspense>
    ) : <ApexView session={view} />;
}
